module.exports = __webpack_public_path__ + "static/img/game5.4d53404.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/3/game5.png
// module id = O2i9
// module chunks = 1